import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import { withRouter } from "react-router";

const Redirect = ({ history }) => {
  const url = useSelector(state => state.redirect.url);
  useEffect(() => {
    url && history.push(url);
  }, [url, history])
  return (
    <div></div>
  );
}

export default withRouter(Redirect)